<template>
  <div class="live-share-code">
    <span class="icon" @click.prevent="back">
      <svg-icon icon-class="back" />
    </span>
    <div class="live-content">
      <div class="title">
        <img alt src="@/assets/redBase.png" />
        <p>
          <span>{{ currentLive.title }}</span>
        </p>
      </div>
      <div class="code">
        <p class="qrcode">
          <qrcode :value="shareUrl" :options="{ size: 132 }" />
        </p>
        <p class="touch" v-longpress="saveAsImage">
          <img alt src="@/assets/buttonBase.png" />
          <br />
          <span>可观看直播</span>
        </p>
      </div>
    </div>
    <div class="live-footer">
      <p>
        <img alt src="@/assets/buttomBase.png" />
      </p>
      <p>鸿合录播 | {{ currentLive.schoolName }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Qrcode from '@/components/Qrcode';

export default {
  name: 'live-share',
  components: {
    Qrcode
  },
  computed: {
    ...mapGetters(['currentLive', 'userInfo']),
    shareUrl() {
      const url = `${window.location.origin}/Lives.html/live/${this.currentLive.id}/${
        this.currentLive.liveId
      }/${this.currentLive.streamCode}/${this.userInfo.mobile}`;
      return url;
    }
  },
  methods: {
    back() {
      this.$router ? this.$router.back() : window.history.back();
    },
    saveAsImage() {
      this.showActionSheet();
    },
    showActionSheet() {
      if (!this.saveActionSheet) {
        this.saveActionSheet = this.$createActionSheet({
          data: [
            {
              content: '保存图片到本地'
            }
          ],
          maskClosable: false,
          onSelect: (item, index) => {
            console.log('index: ', index);
            if (item.content === '保存图片到本地') {
              this.saveImage();
            }
          }
        });
      }
      this.saveActionSheet.show();
    },
    saveImage() {
      const that = this;
      console.log('that: ', that);
      window.html2canvas(document.body).then(function(canvas) {
        const img = window.Canvas2Image.convertToPNG(canvas, 640, 960);
        const base64 = img.src.split(',')[1];
        if (this.$isIos()) {
          window.webkit.messageHandlers.CreturnImgbin.postMessage({ imgbin: base64 });
        } else {
          NativeApi.CreturnImgbin(base64);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.live-share-code {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url('../../../assets/baseImg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .icon {
    position: absolute;
    left: 15px;
    top: 15px;
    z-index: 1001;
    color: #fff;
    font-size: 18px;
  }

  .live-content {
    position: absolute;
    left: 10px;
    bottom: 50px;
    width: 355px;
    height: 329px;
    background-image: url('../../../assets/whiteBase.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .title {
      display: flex;
      justify-content: space-between;

      p {
        width: 200px;
        overflow: hidden;
        font-size: 16px;
        margin-top: 40px;
        margin-right: 20px;
        line-height: 60px;
        text-align: left;

        span {
          display: inline-block;
          vertical-align: middle;
          line-height: 20px;
          word-wrap: break-word;
          word-break: break-all;
        }
      }

      img {
        width: 70px;
        height: 70px;
        margin-top: 30px;
        margin-left: 40px;
      }
    }

    .code {
      margin-top: 35px;
      display: flex;
      justify-content: space-between;

      .qrcode {
        margin-top: 20px;
        margin-left: 30px;
      }

      p.touch {
        margin-right: 50px;
        margin-top: 30px;
        text-align: left;
      }

      img {
        width: 100px;
        height: 87px;
        pointer-events: none;
      }

      span {
        font-size: 12px;
        color: #dc8c1a;
      }
    }
  }

  .live-footer {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;

    p {
      font-size: 10px;
      color: #fff;
      margin-top: 8px;

      img {
        width: 25px;
      }
    }
  }
}
</style>
